import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { getSubmitButtonOptions } from '@rjsf/utils';
/** The `SubmitButton` renders a button that represent the `Submit` action on a form
 */
export default function SubmitButton({ uiSchema }) {
    const { submitText, norender, props: submitButtonProps = {} } = getSubmitButtonOptions(uiSchema);
    if (norender) {
        return null;
    }
    return (_jsx(Box, Object.assign({ marginTop: 3 }, { children: _jsx(Button, Object.assign({ type: 'submit', variant: 'contained', color: 'primary' }, submitButtonProps, { children: submitText })) })));
}
//# sourceMappingURL=SubmitButton.js.map